import { render, staticRenderFns } from "./add-exam-attachment-dialog.vue?vue&type=template&id=08e1c8ec&scoped=true"
import script from "./add-exam-attachment-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-exam-attachment-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./add-exam-attachment-dialog.vue?vue&type=style&index=0&id=08e1c8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1c8ec",
  null
  
)

export default component.exports